import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import * as lmsUserAction from "../../../../redux/actions/lmsUserAction";
import * as toolboxAction from "../../../../redux/actions/toolBoxAction";
import * as lmsReportAction from "../../../../redux/actions/lmsReportAction";
import { useSelector } from "react-redux";
import Loader from "../../../../library/common/Loader";
import Items from "../component/items";
import { ORG_ID, PAGE_SIZE_100, USER_ID } from "../../../../constant/constant";
const ItemsContainerLMS = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const page = location?.state?.page;
  const apiData = location?.state?.apiData;
  const [typeselectdata, setTypeselectdata] = useState([]);
  console.log("LocationItemsContainerLMS", location?.state);
  useEffect(() => {
    handleClear();
  }, []);

  const getLmsDashboardReportDetails = useSelector(
    (state) => state.getLmsDashboardReportDetails
  );
  const getAssignLessonUserListData = useSelector(
    (state) => state?.getAssignLessonUserList
  );
  const coursesUserAssignListData = useSelector(
    (state) => state?.getAssignCourseUserList
  );
  const coursesUserListData = useSelector((state) => state.getUserCoursesList);

  const lessionUserListData = useSelector((state) => state.getUserLessonsList);

  const getToolBoxTalkListResult = useSelector(
    (state) => state.mySafetyMeetingList
  );
  const getScheduleAssignUserStatusData = useSelector(
    (state) => state.getAssignTookBoxUser
  );
  const getScheduleInstructorDetailsData = useSelector(
    (state) => state.getScheduleInstructorDetails
  );
  const getScheduleInstructorDetailsIsLoading = useSelector(
    (state) => state.getScheduleInstructorDetails?.isLoading
  );

  const getLmsCourseLessonSafetyCompeleted_Detail = useSelector(
    (state) => state.getLmsCourseLessonSafetyCompeleted
  );
  const isLoading_complelted = useSelector(
    (state) => state.getLmsCourseLessonSafetyCompeleted?.isLoading
  );
  const getLmsCourseLessonSafetyInCompeleted_Detail = useSelector(
    (state) => state.getLmsCourseLessonSafetyInCompeleted
  );
  const isLoading_Incomplelted = useSelector(
    (state) => state.getLmsCourseLessonSafetyInCompeleted?.isLoading
  );
  function getMoretDetails(data, tab) {
    page === "UsersThatHaveCompleteLesson" // Lessons with Highest Completion
      ? dispatch(lmsAction.getAssignedLessonList(data))
      : page === "TrainingWithLowestParticipation" && tab === "lesson"
      ? dispatch(lmsAction.getAssignedLessonList(data)) // for lesson
      : page === "TrainingWithLowestParticipation" && tab === "course"
      ? dispatch(lmsAction.getAssignedList(data)) // for course
      : page === "TrainingWithLowestParticipation" &&
        (tab === "safety" || tab === "safety meeting")
      ? dispatch(toolboxAction.getScheduleInstructorDetails(data))
      : page === "UsersWithHighestCourseCompletion" // // Course with Highest Completion
      ? dispatch(lmsAction.getAssignedList(data)) //usersWithHighestCompletedTraining
      : page === "usersWithHighestCompletedTraining" && tab === "Complete"
      ? dispatch(lmsReportAction.getCourseLessonSafetyMeetingComplete(data))
      : page === "usersWithMostIncompletedTraining" && tab === "InComplete"
      ? dispatch(lmsReportAction.getCourseLessonSafetyMeetingInComplete(data))
      : page === "SubcontractorCompletedTraingings" ||
        page === "UsersWithMostSafetyMeetings"
      ? dispatch(toolboxAction.getMySafetyMeetingList(data))
      : console.log("");
  }
  useEffect(() => {
    page === "UsersThatHaveCompleteLesson"
      ? getMoretDetails({
          pageNumber: 1,
          pageSize: 100,
          lessonId: apiData?.lessonId,
          isCompleted: true,
          fromDate: apiData?.startDate,
          toDate: apiData?.endDate,
        })
      : page === "UsersWithHighestCourseCompletion"
      ? getMoretDetails({
          pageNumber: 1,
          pageSize: 100,
          courseId: apiData?.courseId,
          isCompleted: true,
          fromDate: apiData?.startDate,
          toDate: apiData?.endDate,
        })
      : page === "usersWithMostIncompletedTraining"
      ? getMoretDetails(
          {
            pageNumber: 1,
            pageSize: PAGE_SIZE_100,
            search: "",
            catIds: "",
            statusId: 2,
            userId: apiData?.userId,
            orgId: ORG_ID(),
            fromDate: apiData?.startDate,
            toDate: apiData?.endDate,
            divisionId: apiData?.divisionId,
            trainingType: [],
          },
          "InComplete"
        )
      : page === "usersWithHighestCompletedTraining"
      ? getMoretDetails(
          {
            pageNumber: 1,
            pageSize: PAGE_SIZE_100,
            search: "",
            catIds: "",
            statusId: 1,
            userId: apiData?.userId,
            orgId: ORG_ID(),
            fromDate: apiData?.startDate,
            toDate: apiData?.endDate,
            divisionId: apiData?.divisionId,
            trainingType: [],
          },
          "Complete"
        )
      : page === "SubcontractorCompletedTraingings"
      ? getMoretDetails({
          page: 1,
          pageSize: PAGE_SIZE_100,
          search: "",
          userId: apiData?.userId,
          tabId: 3,
          divisionId:
            apiData.divisionId === "AllDivision" ? 0 : apiData.divisionId,
          fromDate: apiData.startDate,
          toDate: apiData.endDate,
          IsInstructor: false,
        })
      : page === "UsersWithMostSafetyMeetings"
      ? getMoretDetails({
          page: 1,
          pageSize: PAGE_SIZE_100,
          search: "",
          userId: apiData?.userId,
          tabId: 3,
          divisionId:
            apiData.divisionId === "AllDivision" ? 0 : apiData.divisionId,
          fromDate: apiData.startDate,
          toDate: apiData.endDate,
          IsInstructor: true,
        })
      : page === "TrainingWithLowestParticipation" &&
        location?.state?.type === "Course"
      ? getMoretDetails(
          {
            pageNumber: 1,
            pageSize: 100,
            courseId: apiData?.courseId,
            isCompleted: false,
            fromDate: apiData.startDate,
            toDate: apiData.endDate,
          },
          "course"
        )
      : page === "TrainingWithLowestParticipation" &&
        location?.state?.type === "Lesson"
      ? getMoretDetails(
          {
            pageNumber: 1,
            pageSize: 100,
            lessonId: apiData?.lessonId,
            isCompleted: false,
            fromDate: apiData.startDate,
            toDate: apiData.endDate,
          },
          "lesson"
        )
      : page === "TrainingWithLowestParticipation" &&
        location?.state?.type === "Safety Meeting"
      ? getMoretDetails(
          {
            userId: apiData?.userId,
            orgId: ORG_ID(),
            fromDate: apiData.startDate,
            toDate: apiData.endDate,
            divisionId:
              apiData?.divisionId === "AllDivision" ? 0 : apiData?.divisionId,
            filterBy: 3,
            toolboxTalkId: apiData?.toolboxTalkId,
            toolboxTalkVersionId: apiData?.toolboxTalkVersionId,
            //scheduleId: apiData?.scheduleId,
            page: 1,
            pageSize: PAGE_SIZE_100,
          },
          "safety"
        )
      : console.log();
  }, []);
  const userTRainingLoadin =
    coursesUserListData.isLoading ||
    lessionUserListData.isLoading ||
    getToolBoxTalkListResult.isLoading ||
    getScheduleInstructorDetailsData.isLoading ||
    getScheduleInstructorDetailsIsLoading;

  function handleClear() {
    dispatch(lmsUserAction.clearCourseList());
    dispatch(lmsUserAction.clearLesssonList());
    dispatch(lmsAction.getAssignedLessonListClear());
    dispatch(lmsAction.getAssignedListClear());
    dispatch(toolboxAction.scheduleUserCountStatusClear());
    dispatch(lmsReportAction.clearDashboardDetails());
    dispatch(toolboxAction.clearMySafetyMeetingList());
    dispatch(lmsReportAction.clearCourseLessonSafetyMeetingComplete());
    dispatch(lmsReportAction.clearCourseLessonSafetyMeetingInComplete());
  }
  return (
    <div>
      {(getLmsDashboardReportDetails.isLoading ||
        getAssignLessonUserListData?.isLoading ||
        coursesUserAssignListData?.isLoading ||
        getScheduleAssignUserStatusData.isLoading ||
        isLoading_complelted ||
        isLoading_Incomplelted ||
        getScheduleInstructorDetailsIsLoading) && <Loader />}
      <Items
        page={page}
        getLmsDashboardReportDetails={getLmsDashboardReportDetails}
        getMoretDetails={getMoretDetails}
        apiData={apiData}
        lessonUserAssignListData={getAssignLessonUserListData?.dataresult}
        coursesUserAssignListData={coursesUserAssignListData?.dataresult}
        coursesUserListData={coursesUserListData?.data}
        lessionUserListData={lessionUserListData?.data}
        getToolBoxTalkListResult={getToolBoxTalkListResult?.data}
        getScheduleAssignUserStatusData={
          getScheduleAssignUserStatusData?.data?.users
        }
        location={location}
        userTRainingLoadin={userTRainingLoadin}
        handleClear={handleClear}
        getScheduleInstructorDetailsData={getScheduleInstructorDetailsData}
        getLmsCourseLessonSafetyCompeleted_Detail={
          getLmsCourseLessonSafetyCompeleted_Detail?.data?.result
        }
        getLmsCourseLessonSafetyInCompeleted_Detail={
          getLmsCourseLessonSafetyInCompeleted_Detail?.data?.result
        }
        typeselectdata={typeselectdata}
        setTypeselectdata={setTypeselectdata}
      />
    </div>
  );
};

export default ItemsContainerLMS;
